import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { Size } from '~/types/ThemeTypes'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { FontColor, SeparatorBorder } = themeColorSectionKeys.defaults
const { DataContainer } = themeColorSectionKeys.defaults.Background
const { ModalOverlay } = themeColorSectionKeys.defaults

const modalStyleParts = [
  'dialog',
  'header',
  'headerText',
  'footer',
  'dialogContainer',
  'body',
  'closeButton',
  'modalOverlay',
] as const

export type MangoModalSizes = Size.sm | Size.md | Size.lg | Size.xl

const helpers = createMultiStyleConfigHelpers(modalStyleParts)

export const MangoModalStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    dialogContainer: {
      color: FontColor,
      textStyle: textStyleKeys.Body2,
      alignSelf: 'stretch',
    },
    modalOverlay: {
      backgroundColor: ModalOverlay,
    },
    dialog: {
      backgroundColor: DataContainer,
      borderRadius: '0.5rem',
      alignSelf: 'center',
      width: '100%',
    },
    header: {
      display: 'flex',

      justifyContent: 'space-between',
      alignItems: 'center',
      height: '3.75rem',

      paddingX: '1rem',
      paddingY: '0.75rem',
      borderBottom: '2px solid',
      borderBottomColor: SeparatorBorder,
    },
    headerText: {
      textStyle: textStyleKeys.Body1_Bold,
      color: FontColor.Default,
      userSelect: 'none',
    },
    footer: {
      display: 'flex',
      height: '3.75rem',
      paddingX: '1rem',
      gap: '0.625rem',
      flexShrink: 0,
      paddingY: 0,
      borderTop: '2px solid',
      borderTopColor: SeparatorBorder,
    },
    body: {
      padding: '1.25rem',
    },
    closeButton: {},
  },
  sizes: {
    [Size.sm]: {
      dialog: {
        maxWidth: '25rem',
      },
    },
    [Size.md]: {
      dialog: {
        maxWidth: '32rem',
      },
    },
    [Size.lg]: {
      dialog: {
        maxWidth: '42rem',
        maxHeight: '44rem',
      },
    },
    [Size.xl]: {
      dialog: {
        maxWidth: '50rem',
        maxHeight: '42rem',
      },
    },
  },
  defaultProps: {
    size: Size.md,
  },
})

const themeKey = getName({ MangoModalStyle })
export const useMangoModalStyles = (props?: StyleThemingProps) =>
  useCustomMultiStyleConfig<typeof modalStyleParts>(themeKey, props)

export const createMangoModalStylesContext =
  createCustomStyleContext<typeof modalStyleParts>(themeKey)
